import { getActivePinia } from 'pinia';
import { usePdpRecommendedProductsAnalyticsStore } from '~/stores/pdpRecommendedProductsAnalyticsStore/pdpRecommendedProductsAnalyticsStore';
import type { PdpRecommendedProductsAttribution } from './types';

export function getPdpRecommendedProductsAttributionForSku(
  sku: string
): PdpRecommendedProductsAttribution | undefined {
  if (!getActivePinia()) {
    return undefined;
  }

  return usePdpRecommendedProductsAnalyticsStore().getAttribution(sku);
}

export function hasPdpRecommendedProductsAttributionForSkus(
  skus: string[]
): boolean {
  if (!getActivePinia()) {
    return false;
  }

  return usePdpRecommendedProductsAnalyticsStore().hasAttributionInCart(skus);
}
